import React, { useState } from 'react';
import AdminAuth from './components/AdminAuth';
import AdminSidebar from './components/AdminSidebar';
import AdminDashboard from './components/AdminDashboard';
import ContactsSection from './components/ContactsSection';
import QuotationsSection from './components/QuotationsSection';
import NewsletterSection from './components/NewsletterSection';
import DownloadsSection from './components/DownloadsSection';
import FileManagementSection from './components/FileManagementSection';
import PopupManagementSection from './components/PopupManagementSection';
import ProductManagementSection from './components/ProductManagementSection';
import ProductEnquiriesSection from './components/ProductEnquiriesSection';
import CategoryManagementSection from './CategoryManagementSection';

const AdminPanel = () => {
  const [activeSection, setActiveSection] = useState('dashboard');

  const renderSection = () => {
    switch (activeSection) {
      case 'dashboard':
        return <AdminDashboard />;
      case 'contacts':
        return <ContactsSection />;
      case 'quotations':
        return <QuotationsSection />;
      case 'newsletters':
        return <NewsletterSection />;
      case 'downloads':
        return <DownloadsSection />;
      case 'files':
        return <FileManagementSection />;
      case 'popups':
        return <PopupManagementSection />;
      case 'product-enquiries':
        return <ProductEnquiriesSection />;
      case 'categories':
        return <CategoryManagementSection />;
      case 'products':
        return <ProductManagementSection />;
      default:
        return <AdminDashboard />;
    }
  };

  return (
    <AdminAuth>
      <div className="flex h-screen bg-gray-50">
        <AdminSidebar activeSection={activeSection} setActiveSection={setActiveSection} />
        <div className="flex-1 overflow-auto bg-white">
          <div className="min-h-full">
            {renderSection()}
          </div>
        </div>
      </div>
    </AdminAuth>
  );
};

export default AdminPanel;
